const BoxButton = ({ className = "", onClick, icon, title }) => {
    return (
        <div
            className={ `rounded-lg border-solid border-border	border-2 cursor-pointer hover:shadow-secondary shadow-tertiary h-[68px] tablet:h-[80px] flex flex-col items-center justify-center w-full ${className}` }
            onClick={ onClick }
        >
            { icon }

            <p className=" mt-1 tablet:text-lg font-semibold leading-tight">{ title }</p>
        </div>
    )
}

export default BoxButton
